/**
 * 401 Unauthorized 自動リダイレクト処理
 *
 * @file authRedirect.ts
 * @version 1.0.0
 * @author CrossBorderECMall Development Team
 * @summary
 * セッション切れ（401 Unauthorized）検出時にログイン画面へ安全にリダイレクトする。
 * 重複リダイレクト防止・ループ防止のロジックを集約。
 */

let isRedirecting = false;

/**
 * ログイン関連APIかどうかを判定（これらの401はリダイレクト対象外）
 */
function isAuthEndpoint(url: string): boolean {
  const authPaths = [
    '/auth/login',
    '/auth/register',
    '/auth/csrf-token',
    '/auth/refresh',
    '/auth/reset-password',
    '/auth/change-password',
    '/auth/verify-email',
    '/auth/profile',
    '/auth/me/password',
    '/auth/me/email-change-request',
    '/2fa/enable',
    '/2fa/disable',
  ];
  return authPaths.some((path) => url.includes(path));
}

/**
 * 401レスポンスに対する共通処理
 * @param requestUrl - 401が発生したリクエストのURL
 * @returns true: リダイレクト実行、false: リダイレクトスキップ
 */
export function handleUnauthorized(requestUrl?: string): boolean {
  if (window.location.pathname === '/login') {
    return false;
  }

  if (requestUrl && isAuthEndpoint(requestUrl)) {
    return false;
  }

  if (isRedirecting) {
    return false;
  }

  isRedirecting = true;
  window.location.href = '/login';
  return true;
}
